import React, {useState, useEffect} from 'react';
import {formatCentsPrice} from "../utility/cartHelpers";
import {getRealUnitPrice} from "../../models/cartItem";
import CatchErrors from "../../../Utility/CatchErrors";
import clsx from 'clsx';

/**
 * NEW 2025-05 - show the raw prices so that agents can understand the calculations.
 *
 * @param item
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function AgentPriceInfo({item, ...props}) {

  const {cataloguePrice, regularUnitPrice, regularOptionsPrice = 0, agentUnitPrice, quantity} = item;
  const hasPromoPrice = cataloguePrice && (cataloguePrice !== regularUnitPrice) && (!regularOptionsPrice);
  const hasOptions = !!regularOptionsPrice;

  const fullPrice = getRealUnitPrice(item);

  const gridClasses= "grid grid-cols-2";
  const leftClasses = "text-xs px-1";
  const rightClasses = "text-sm px-1 text-right";

  return (
    <CatchErrors>
      <div className="bg-agent-purple text-white mt-2">
        {(quantity > 1) && <div className={'text-white bg-blue-800 py-1'}>
          <div className="text-center text-xs">price for <b>each</b> of <b>{quantity}</b></div>
        </div>}

        {hasPromoPrice &&
          <div className={gridClasses}>
            <div className={leftClasses}>w/o sale</div>
            <div className={rightClasses}>{formatCentsPrice(regularUnitPrice)}</div>
          </div>
        }

        {hasOptions && <div className={gridClasses}>
          <div className={leftClasses}>base each</div>
          <div className={rightClasses}>{formatCentsPrice(cataloguePrice)}</div>
        </div>}

        {hasOptions && <div className={gridClasses}>
          <div className={leftClasses}>+add-ons</div>
          <div className={rightClasses}>{formatCentsPrice(regularOptionsPrice)}</div>
        </div>}

        <div className={gridClasses}>
          <div className={leftClasses}>full price</div>
          <div className={rightClasses}>{formatCentsPrice(fullPrice)}</div>
        </div>

        {agentUnitPrice && <div className={clsx(gridClasses, 'bg-green-700')}>
          <div className={leftClasses}>agent price</div>
          <div className={rightClasses}>{formatCentsPrice(agentUnitPrice)}</div>
        </div>}
      </div>
    </CatchErrors>
  )
}
